import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { User } from 'src/app/shared/interfaces/user.interface';

@Injectable({
  providedIn: 'root',
})
export class AccountService {
  baseUrl = '@cec-api/account';
  constructor(private http: HttpClient) {}

  get(): Promise<any> {
    return this.http.get(this.baseUrl).toPromise();
  }

  update(body: any): Promise<any> {
    return this.http.post(this.baseUrl, body).toPromise();
  }

  register(body: any): Promise<any> {
    return this.http.post('@cec-api/register', body).toPromise();
  }

  newConvert(body: any): Promise<any> {
    return this.http.post('@cec-api/novo-convertido', body).toPromise();
  }

  registerWithAvatar(formData: FormData): Promise<any> {
    return this.http.post('@cec-api/register', formData).toPromise();
  }
}
